export const SpinnerTheme = {
  baseStyle: {
    borderWidth: "3px",
  },
};
